import { dialogIcon } from '@aibees/elephant/components/save-dialog/sx';
import { SaveRecordAction } from '@aibees/elephant/hooks';
import { FormDialogConfig } from '@aibees/shared/components';
import * as Yup from 'yup';

export const scheme = Yup.object().shape({
  owner: Yup.string(),
  overwriteOwner: Yup.boolean(),
  selectOwner: Yup.boolean(),
  [SaveRecordAction.CONTACT_ENRICH_EMAIL]: Yup.boolean(),
  [SaveRecordAction.CONTACT_REVERIFY_EMAIL]: Yup.boolean(),
  [SaveRecordAction.BASIC_SAVE]: Yup.boolean(),
  [SaveRecordAction.CONTACT_REVEAL_PROFILE]: Yup.boolean(),
  // [SaveRecordAction.AI_POWERED_ACCOUNT]: Yup.boolean(),
  // [SaveRecordAction.AI_POWERED_CONTACT]: Yup.boolean(),
});

export const config: FormDialogConfig = {
  title: 'Add to List',
  titleSx: { pl: 3 },
  icon: 'list-add',
  iconSx: dialogIcon,
  submitButtonProps: {
    children: 'Save',
    size: 'medium',
    variant: 'contained',
    color: 'primary',
  },
  closeButton: {
    children: 'Cancel',
    size: 'medium',
    variant: 'text',
    sx: { fontWeight: 'normal', color: (p) => p.palette.common.black },
  },
  contentSx: { gap: 1, py: 1, px: 0 },
  actionsSx: { py: 1, m: 0, px: 2 },
  scheme,
  defaultValues: {
    overwriteOwner: true,
    selectOwner: true,
    [SaveRecordAction.CONTACT_ENRICH_EMAIL]: true,
    [SaveRecordAction.CONTACT_REVERIFY_EMAIL]: true,
    [SaveRecordAction.CONTACT_REVEAL_PROFILE]: false,
    [SaveRecordAction.BASIC_SAVE]: true,
    [SaveRecordAction.AI_POWERED_ACCOUNT]: true,
    [SaveRecordAction.AI_POWERED_CONTACT]: true,
  },
};
